import React from 'react';
import { Modal } from 'antd';
import './popup.css';

/**
 * AppModal — Popup กลางของระบบ
 * ใช้แทน <Modal> ของ Ant Design ทุกที่
 *
 * Props:
 *   ทุก props ของ Ant Modal + เพิ่ม:
 *   - icon       : ReactNode ไอคอนแสดงข้าง title
 *   - subtitle   : string ข้อความรองใต้ title
 *   - noPadding  : boolean ปิด padding ใน body (เช่น ใส่ Table เต็ม)
 */
const AppModal = ({
  icon,
  subtitle,
  noPadding = false,
  title,
  children,
  className = '',
  ...rest
}) => {
  // สร้าง custom title ถ้ามี icon/subtitle
  const renderTitle = () => {
    if (!title && !icon && !subtitle) return null;
    return (
      <div className="app-modal-header">
        {icon && <div className="app-modal-header-icon">{icon}</div>}
        <div className="app-modal-header-text">
          {title && <h3 className="app-modal-title">{title}</h3>}
          {subtitle && <p className="app-modal-subtitle">{subtitle}</p>}
        </div>
      </div>
    );
  };

  return (
    <Modal
      title={renderTitle()}
      centered
      destroyOnHidden
      className={`app-modal ${noPadding ? 'app-modal-no-padding' : ''} ${className}`}
      {...rest}
    >
      {children}
    </Modal>
  );
};

export default AppModal;
